module.exports = __webpack_public_path__ + "img/s2l.b2f5b3a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/s2l.svg?1k5k71
// module id = 1089
// module chunks = 0